export const formsSchema = {
  month: {
    required: 'ra.validation.required',
  },
  visit: {
    required: 'ra.validation.required',
  },
  notes: {
    required: 'ra.validation.required',
  },
  rfv: {
    required: 'ra.validation.required',
  },
  subscribers: {
    required: 'ra.validation.required',
  },
};
